import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import type { CompetitorsColumns } from '../types'
import type { TranslationsConfigCompetitorsDataSource } from '@app/types/dataSource/TranslationsConfigDataSource'
import type { Column } from '@app/components/base/Table/types'

const columnTitleMap: Record<keyof CompetitorsColumns, string> = {
  network: 'Сеть конкурента',
  text: 'Адрес конкурента',
  salesOrganization: 'Сбытовая организация',
  clustersGroup: 'Группа кластеров',
  cluster: 'Кластер',
  removeButton: ''
}

const getColumnsOptions = (): Array<Column<CompetitorsColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof CompetitorsColumns>

  return columnKeys.map(key => {
    const column: Column<CompetitorsColumns> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumns = (): Array<Column<TranslationsConfigCompetitorsDataSource>> =>
  [
    ...getColumnsFromMap<CompetitorsColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<TranslationsConfigCompetitorsDataSource>>

export default getColumns
